import React, { Component } from 'react';

import escButton from '../../../../assets/images/esc.svg';
export default class HeaderAssessmentReport extends Component {
  render() {
    return (
      <div onClick={() => {
        this.props.history.push('/dashboard');
      }} className="esc-button">
        <img src={escButton} alt="" />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Header/components/HeaderAssessmentReport/HeaderAssessmentReport.js